
export const AppConstants = {
    INDEX_DB: {
        dbName: 'cliv-v2',
        version:3,
        store: {
            inspections: "inspections",
            savedInspections: "savedInspections",
            images: 'images',
            masterData: 'masterData',
            openedInspection: 'openedInspection'
        }
    },
    ID_PREFIX: 'newid',
    IMAGE_URL_SEPARATOR: ',',
    REQUEST_ID_HEADER: 'X-Request-Id',
    DEFAULT_MODULE: 'VisualCheck',
    LOCATION_VERIFICATION_CONTROL_POINT_NAMES: [
        'Factory Final Inspection',
        'Factory Inspection',
    ] as const,
    APP_NAME: 'inspect'
}